"use client";

import { Skeleton } from "@/components/ui/skeleton";

export function ProductCardSkeleton() {
  return (
    <div className="flex w-full flex-col gap-3.5">
      <Skeleton className="w-full" style={{ aspectRatio: "0.728" }} />

      <div className="flex w-full flex-col space-y-0.5 p-0.5 sm:space-y-1 sm:p-2">
        <div className="flex w-full items-center justify-between gap-2 sm:flex-col sm:items-start sm:gap-1">
          <Skeleton className="h-3 w-20 sm:h-4 sm:w-28" />
          <div className="flex items-center gap-1.5">
            <Skeleton className="h-3 w-8 sm:h-4" />
            <Skeleton className="h-3 w-8" />
          </div>
        </div>
        <Skeleton className="h-3 w-3/4 sm:h-4" />
      </div>
    </div>
  );
}
